import { useEffect, useRef, useState } from 'react'

const defaultPageSortModel = () => ({
    filterModel: {},
    paginationModel: { page: 0, pageSize: 10 },
    sortModel: [],
})

export const useLoadAll = ({ listFilterPageSort, loadAll = () => { }, params = {}, reloadCounter }) => {
    const timeoutRef = useRef(null)
    const [prevPayload, setPrevPayload] = useState()

    useEffect(() => {
        const hasPageSort =
            listFilterPageSort != null &&
            typeof listFilterPageSort === 'object' &&
            Object.keys(listFilterPageSort).length > 0
        const hasOtherFilters =
            params?.otherFilters != null &&
            typeof params.otherFilters === 'object' &&
            Object.keys(params.otherFilters).length > 0

        // Liste embedded negli step del wizard restano display:none finché lo step non è attivo: il DataGrid
        // può non emettere mai onFilterPageSortChange, quindi listFilterPageSort resta vuoto e non parte loadAll.
        // Se ci sono otherFilters (es. campaign/segments) forziamo un modello minimo e carichiamo comunque.
        if (!hasPageSort && !hasOtherFilters) {
            return
        }

        const listModel = hasPageSort
            ? { ...defaultPageSortModel(), ...listFilterPageSort }
            : defaultPageSortModel()
        const { filterModel = {}, paginationModel = {}, sortModel } = listModel
        const { page = 0, pageSize = 20 } = paginationModel

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
        }

        timeoutRef.current = setTimeout(() => {
            loadAll(filterModel, sortModel, page + 1, pageSize, params.otherFilters ?? null)
        }, 200)

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
        }
    }, [listFilterPageSort, reloadCounter, params.otherFilters])
}
